/* assets/custom-reset-on-globo-submit.js */
(function () {
  var STORAGE_KEY = 'customProducts';
  var armed = false;
  var fired = false;
  var mo = null;

  function clearCustomProducts() {
    if (fired) return;
    fired = true;

    try {
      if (window.CustomList && typeof window.CustomList.write === 'function') {
        window.CustomList.write([]); // presence.js が write をラップしていれば update も走る
      } else {
        localStorage.setItem(STORAGE_KEY, '[]');
      }
    } catch (e) {}

    // UI反映（念のため）
    try { if (window.CustomList && typeof window.CustomList.updateFloatingCount === 'function') window.CustomList.updateFloatingCount(); } catch (e) {}
    try { if (window.CustomPresence && typeof window.CustomPresence.update === 'function') window.CustomPresence.update(); } catch (e) {}
  }

  function watchCongratsMessage() {
    // すでに監視中なら何もしない
    if (mo) return;

    // Globoの完了メッセージ（あなたのDOMにある）
    var msg = document.querySelector('.wizard__congrats-message');
    if (!msg) return;

    // すでに完了表示済みなら即クリア
    if ((msg.textContent || '').trim()) {
      clearCustomProducts();
      return;
    }

    mo = new MutationObserver(function () {
      if ((msg.textContent || '').trim()) {
        mo.disconnect();
        mo = null;
        clearCustomProducts();
      }
    });

    mo.observe(msg, { childList: true, characterData: true, subtree: true });
  }

  // 「送信ボタンが押された」ことをトリガーに監視を開始
  // （type="button" の submit ボタンでも拾える）
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.gfb__footer .action.next.submit');
      if (!btn) return;

      armed = true;
      fired = false;

      // 送信後に完了UIが出るまで監視（要素が遅れて作られるケースにも対応）
      watchCongratsMessage();

      // 完了メッセージ自体が後から挿入される場合に備えて、短時間だけ再探索
      var start = Date.now();
      var timer = setInterval(function () {
        if (!armed || fired) { clearInterval(timer); return; }
        watchCongratsMessage();
        if (Date.now() - start > 20000) clearInterval(timer); // 保険
      }, 200);
    },
    true
  );

  // 万一「submit」イベントが発火するフォーム構造のときも拾える
  document.addEventListener(
    'submit',
    function () {
      if (!armed) return;
      watchCongratsMessage();
    },
    true
  );
})();
